import { render, staticRenderFns } from "./RouteAdd.vue?vue&type=template&id=8881e5ba"
import script from "./RouteAdd.vue?vue&type=script&lang=js"
export * from "./RouteAdd.vue?vue&type=script&lang=js"
import style0 from "./RouteAdd.vue?vue&type=style&index=0&id=8881e5ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports